import React from 'react';
import { BookingWrapper } from './styled';
import { images } from '../../../Constants/ImageUrls';

function BookingDone(props) {
  const { bookingDoneData, categoryPage, article, ovulation } = props;

  return (
    <BookingWrapper
      ovulation={ovulation}
      categoryPage={categoryPage}
      article={article}
    >
      <img src={images?.tick_consult} alt="" />
      <p>
        {`We have received your details. Our Customer Care agent will
                reach you shortly on +91-${bookingDoneData} to schedule your call.`}
      </p>
    </BookingWrapper>
  );
}

export default BookingDone;
